<template>
    <div class="deal_refund_box">
        <!-- 退款設定 -->
        <div class="deal_title">
            <div>交易管理<span>》</span>退款設定</div>
            <div class="deal_hr">
                <div class="cut_off"></div>
            </div>
        </div>
        <!-- BOX-go -->
        <div>
            <!-- 内容-退款設定 -->
            <div class="deal_content_box">
                <div class="deal_content_title">退款設定</div>
                <div class="deal_content">
                    <div class="content_auto_box">
                        <div class="content_title">退款結果回執通知</div>
                        <p class="content_title_p">
                            當退款單的狀態由退款中變為退款成功、退款關閉或者退款異常時，我們都會按照商戶配置的回調位址，主動通知商戶(僅限通知該訂單的發起商家)。退款結果回執通知開發文檔
                        </p>
                        <p class="content_title_p">
                          若設定多個回調位址，系統將依序通知，前一個位址通知成功後，將不再通知後一個位址。
                        </p>
                        <!-- 進入設定-內容 -->
                        <div class="set_url_box" v-show="setUrlTF">
                            <p>
                                通知URL：
                                <input type="text" class="url_input" v-model="urlInput" placeholder="">
                                <span>刪除</span>
                                <span class="url_input_red">新增</span>
                            </p>
                            <p class="url_button_box">
                                <el-button plain @click="setUrlFun()">取消</el-button>
                                <el-button type="primary">儲存</el-button>
                            </p>
                        </div>
                        <!-- 進入設定-內容-end -->
                        <el-button type="primary" class="content_title_button" v-show="!setUrlTF" @click="setUrlFun()">進入設定</el-button>
                        <hr >
                        <div class="content_title_2">異常退款預設退回商家</div>
                        <p class="content_title_p">
                            可能由於用戶的銀行帳戶結清註銷、台易購帳號註銷等原因，台易購平台無法將退款資金退還用戶。
                        </p>
                        <p class="content_title_p">
                          商家可以開啟“異常退款預設退商家”功能，我們會將退款連同手續費退還交易入帳方的帳戶中，並發送郵件通知。
                        </p>
                        <!-- 進入設定-內容 -->
                        <div class="set_url_box" v-show="setEmailTF">
                            <p class="set_url_radio">
                                預設退還帳戶：
                                <el-radio v-model="radio" label="1">基本帳號</el-radio>
                                <el-radio v-model="radio" label="2">結算銀行帳號</el-radio>
                            </p>
                            <p>
                                接收通知信箱：
                                <input type="text" class="url_input" v-model="emailInput" placeholder="">
                                <span>刪除</span>
                                <span class="url_input_red">新增</span>
                            </p>
                            <p class="url_button_box">
                                <el-button plain @click="setEmailFun()">取消</el-button>
                                <el-button type="primary">儲存</el-button>
                            </p>
                        </div>
                        <!-- 進入設定-內容-end -->
                        <el-button type="primary" class="content_title_button" @click="setEmailFun()" v-show="!setEmailTF">進入設定</el-button>
                    </div>
                </div>
            </div>
            
            <!-- BOX-end -->
        </div>
        <!-- deal_refund_box -->
    </div>
</template>

<script>
export default {
    name: 'LoginDealRefundSetting',
    data() {
        return {
            setUrlTF: false,
            setEmailTF: false,
            urlInput: '',
            emailInput: '',
            radio: '1',
        }
    },
    methods: {
        setUrlFun(){
            this.setUrlTF = !this.setUrlTF;
        },
        setEmailFun(){
            this.setEmailTF = !this.setEmailTF;
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 申請退款 */
    .input_box {
        width: 100px;
    }
    .textarea_box {
        width: 350px;
        margin-left: 10px;
    }
    .input_pass {
        width: 350px;
    }
    .input_pass_number {
        margin-left: 10px;
        color: #4d80e7;
    }
    .el-input__inner {
        height: 20px;
    }
    .deal_refund_box {
        margin: 20px;
        font-size: 15px;
        color: black;
    }
    .deal_title {
        display: flex;
        justify-content: flex-start;
        margin: 30px 0;
    }
    .deal_title span {
        margin-left: 15px;
        margin-right: 8px;
    }
    .deal_title .deal_hr {
        flex: 1;
        margin-left: 18px;
    }
    .deal_title .deal_hr .cut_off {
        height: 3px;
        background: black;
        margin-top: 8px;
    }
/* 内容 */
    .datetime_box > span {
        margin: 10px;
    }
    .deal_content_box {
        font-size: 13px;
        margin-top: 20px;
    }
    .deal_content_title {
        height: 42px;
        background: #666666;
        line-height: 42px;
        color: white;
        padding-left: 14px;
    }
    .deal_content {
        box-sizing: border-box;
        border: 1px solid #666666;
        background: #ffffff;
        color: #777777;
        padding: 5px 25px;
    }
    .content_auto_box {
        padding: 32px; 
    }
    .content_title {
        font-size: 15px;
        font-weight: bold;
        padding-left: 8px;
        padding-right: 50px;
        line-height: 17px;
        background: url(../../../../assets/img/login/logindeal/icon_recommend.png) no-repeat 136px 0px;
        border-left: 8px solid #e73262; 
        margin-bottom: 22px;
    }
    .content_title_2 {
        font-size: 15px;
        font-weight: bold;
        padding-left: 8px;
        padding-right: 50px;
        line-height: 17px;
        border-left: 8px solid #e73262; 
        margin: 24px 0 22px 0;
    }
    .content_title_p {
        width: 650px;
        line-height: 21px;
        margin-left: 15px;
    }
    .set_url_box {
        margin: 38px 0;
        margin-left: 15px;
    }
    .set_url_box .url_input {
        border: 1px solid #cccccc;
        padding: 4px 8px;
        width: 460px; 
    }
    .set_url_radio {
        margin-bottom: 30px;
    }
    .set_url_box span {
        padding-bottom: 2px;
        border-bottom: 1px solid ;
        margin-left: 18px;
        cursor: pointer;
    }
    .url_button_box {
        margin-top: 40px;
    }
    .set_url_box .el-button {
        padding: 6px 30px;
    }
    .url_input_red {
        color: #e73262;
    }
    .content_title_button { 
        padding: 6px 8px;
        margin: 26px 0 30px 15px;
    }
</style>
